import { render, staticRenderFns } from "./sceRouteButton.vue?vue&type=template&id=3634a067"
import script from "./sceRouteButton.vue?vue&type=script&lang=js"
export * from "./sceRouteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports